<script>
  import { _ } from "svelte-i18n"
  import { previews_tracking, user_valid, previews_are_zoomed } from '../stores.js'
  import { handleUpsell } from '../modules/helpers'
	import PreviewsStepperButton from './PreviewsStepperButton.svelte'

  let initial = 0
  let min = -8
  let max = 14
  let step = $previews_are_zoomed ? 0.5 : 2
	let increase_disabled = false
	let decrease_disabled = false

  function increase() {
    if (!increase_disabled) $previews_tracking = Number($previews_tracking) + step
  }
	function decrease(){
		if (!decrease_disabled) $previews_tracking = Number($previews_tracking) - step
  }
  function reset() {
    $previews_tracking = initial
  }
	$: {
		if ($previews_tracking <= min) decrease_disabled = true
		else decrease_disabled = false
		if ($previews_tracking >= max) increase_disabled = true
    else increase_disabled = false
    if ($user_valid) localStorage.setItem("previews_tracking", $previews_tracking)
	}
</script>

<div class="wrapper" 
  class:pro_only={!$user_valid}
  on:click={() => handleUpsell('tracking')}>
  <PreviewsStepperButton on:click={reset} active={$previews_tracking == initial}>{$_('buttons.normal')}</PreviewsStepperButton> 
  <span> / </span>
  <PreviewsStepperButton on:click={decrease} disabled={decrease_disabled}>{$_('buttons.tighter')}</PreviewsStepperButton>
  <span> / </span>
  <PreviewsStepperButton on:click={increase} disabled={increase_disabled}>{$_('buttons.looser')}</PreviewsStepperButton>
</div>

<style>
  .wrapper {
    position: relative;
    margin-right: 4rem;
		cursor: default;
  }
  span {
    color: var(--c-text-faded-big);
  }
</style>